import React, {useState} from "react";
import * as palette from "../Variables";
import styled from "styled-components";

const StyledCompetitor = styled.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    column-gap: 6px;

    @media (min-width: 768px) {
        column-gap: 16px;
    }

    .img {
        width: 32px;
        height: 32px;
        border-radius: 32px;
        overflow: hidden;

        @media (min-width: 768px) {
            width: 64px;
            height: 64px;
        }
    }

    p {
        margin: 0;
    }
`;

const Competitor = ({src, alt, name}) => {
    return (
        <StyledCompetitor>
            <div className={"img"}>
                <img src={src} alt={alt}/>
            </div>
            <p>{name}</p>
        </StyledCompetitor>
    )
}

export default Competitor;